import { _ } from 'utils'

export default () => ([
    {
        id: 'reception',
        name: _('map_editor.widget.reception'),
    },
    {
        id: 'event_info',
        name: _('map_editor.widget.event_info'),
    },
    {
        id: 'embedded',
        name: _('map_editor.widget.embedded'),
    },
    {
        id: 'external_link',
        name: _('map_editor.widget.external_link'),
    },
])
